<template>
  <main-template :header="header" :is-loading="isLoading">
    <div class="container-fluid container">
      <h1>Villa Management</h1>
      <div v-html="villaManagement"></div>
    </div>
  </main-template>
</template>

<script>
import { get } from 'lodash'
import { COVER_IMG_TYPE, HERO_TEXT_CONFIG_KEY, SERVICE_KEY } from '@/configs/constants'
import { delay } from '@/helpers'
import MainTemplate from '@/templates/MainTemplate'
import ConfigApi from '@/api/config-api'

export default {
  name: 'VillaManagement',
  components: { MainTemplate },
  data () {
    return {
      isLoading: false,
      villaManagement: '',
      header: {
        className: '',
        style: '',
        imgPath: '',
        isShow: true,
        resizeLogo: true,
        heroText: {
          headline: '',
          subHeadline: ''
        }
      }
    }
  },
  computed: {
    prefetchItems () {
      return this.$store.state.prefetchItems
    }
  },
  async serverPrefetch () {
    await this.preparePrefetchItems(true)
  },
  async created () {
    try {
      this.isLoading = true
      await this.preparePrefetchItems(false)
      await delay(300)
      this.isLoading = false
    } catch (err) {
      // console.log(err)
    }
  },
  methods: {
    async preparePrefetchItems (isServerPrefetch) {
      let prefetchItems = this.prefetchItems
      if (prefetchItems === null) {
        const promises = [
          ConfigApi.coverImgUrl(COVER_IMG_TYPE.VILLA_MANAGEMENT),
          ConfigApi.configByKey(SERVICE_KEY.VILLA_MANAGEMENT),
          ConfigApi.configByKey(HERO_TEXT_CONFIG_KEY.VILLA_MANAGEMENT)
        ]

        const result = await Promise.all(promises)

        const coverImg = result[0]
        const villaManagement = get(result[1], 'configValue', '')

        const heroTextConfig = result[2]
        const heroTextValue = get(heroTextConfig, 'configValue', '{}')
        const heroText = JSON.parse(heroTextValue)

        const header = {
          className: '',
          style: '',
          imgPath: coverImg.url,
          isShow: true,
          resizeLogo: true,
          heroText: heroText
        }

        prefetchItems = {
          header,
          villaManagement
        }
      }

      if (isServerPrefetch) {
        this.$store.dispatch('initPrefetchItems', prefetchItems)
      } else {
        Object.assign(this, prefetchItems)

        this.$store.dispatch('clearPrefetchItems')
      }
    }
  }
}
</script>

<style scoped>

</style>
